<template>
  <v-container>
    <v-layout>
      <v-container>
        <v-card>
          <v-toolbar card color="#0C116F">
            <v-toolbar-title class="white--text">Update Tags for Entities via JSON Upload (Needs to be tested/approved)</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-form enctype="multipart/form-data">
              <input type="file" id="file" ref="file" v-on:change="handleFileUpload" />
              <v-btn @click="submit" color="primary">Update Tags</v-btn>
              <v-btn @click="cancel" color="grey">Cancel</v-btn>
            </v-form>

            <v-divider class="my-4"></v-divider>

            <div>
              <p>
                Upload a JSON file with <code>Uuid</code> and <code>Tags</code> to update tag values in DynamoDB.
              </p>
              <p><strong>Format requirements:</strong></p>
              <ul>
                <li>The file must be a valid JSON array.</li>
                <li>Each item must include:
                  <ul>
                    <li><code>Uuid</code> (REQUIRED): String, used as primary key (id).</li>
                    <li><code>Tags</code> (REQUIRED): List of strings to overwrite existing tags.</li>
                  </ul>
                </li>
                <li>Example:
                  <pre>
[
  {
    "Uuid": "123e4567-e89b-12d3-a456-426614174000",
    "Tags": ["FINANCE", "TEST"]
  },
  {
    "Uuid": "789e1234-e89b-12d3-a456-426614174111",
    "Tags": ["RESEARCH", "EXTERNAL"]
  }
]</pre>
                </li>
              </ul>
              <p>
                Both the first revision (0) and the latest revision of each entity will be updated.
              </p>
            </div>

          </v-card-text>
          <v-snackbar
            v-model="snackbar"
            :timeout="6000"
            :top="true"
            :vertical="true"
          >
            {{ text }}
            <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
          </v-snackbar>

        </v-card>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';
import Config from '../utils/Config';
import AmplifyStore from '../store/store';

export default {
  data() {
    return {
      file: null,
      snackbar: false,
      text: '',
    };
  },
  mounted() {
    const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken;
    axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`;
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    cancel() {
      this.$router.go(-1);
    },
    submit() {
      this.$emit('TriggerLoading', true);

      const formData = new FormData();
      formData.append('file', this.file);

      axios.post(`${Config.API_URL}/tag-update`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(response => {
        this.text = response.data.message || 'Tags updated successfully';
        this.snackbar = true;
        this.$emit('TriggerLoading', false);
      })
      .catch(error => {
        this.text = (error.response && error.response.data && error.response.data.message) || 'An error occurred while updating tags.';
        this.snackbar = true;
        this.$emit('TriggerLoading', false);
      });
    },
  },
};
</script>
